import React from 'react';

const Services: React.FC = () => {
  const services = [
    {
      icon: "/images/icons/brand.png",
      title: "Logo Design & Visual Identity",
      description: "We craft distinctive and memorable logos that capture the essence of your brand and leave a lasting impression.",
      bgColor: "bg-brand-orange"
    },
    {
      icon: "/images/icons/rocket-lunch.png",
      title: "Social Media Marketing",
      description: "We create data-driven, engaging campaigns that connect with your audience and amplify your brand across digital platforms.",
      bgColor: "bg-brand-blue"
    },
    {
      icon: "/images/icons/video-camera-alt.png",
      title: "Video Production",
      description: "Our team produces compelling video content—from concept to execution—that tells your story with clarity and emotion.",
      bgColor: "bg-brand-orange"
    },
    {
      icon: "/images/icons/calendar.png",
      title: "Event Branding",
      description: "We design immersive brand experiences for events, ensuring every touchpoint reflects your identity and leaves a powerful impact.",
      bgColor: "bg-brand-blue"
    },
    {
      icon: "/images/icons/website-design.png",
      title: "Web Design & Development",
      description: "We create stunning, responsive websites that not only look amazing but also deliver exceptional user experiences and drive results.",
      bgColor: "bg-brand-orange"
    }
  ];

  return (
    <section id="features" className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-medium text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Strategic design solutions for businesses, organizations, and startups that want to build strong, clear, and memorable brands
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group text-center p-8 rounded-2xl bg-white/10 backdrop-blur-lg border border-gray-200 hover:bg-white/20 hover:shadow-2xl hover:shadow-brand-orange/20 transition-all duration-500 animate-fade-in-up transform hover:scale-105 hover:-translate-y-2" 
              style={{animationDelay: `${0.2 + index * 0.2}s`}}
            >
              <div className={`w-16 h-16 mx-auto mb-6 ${service.bgColor} rounded-2xl flex items-center justify-center`}>
                <img 
                  src={service.icon} 
                  alt={service.title}
                  className="w-8 h-8 object-contain"
                />
              </div>
              <h3 className="text-xl font-normal text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
